export default {
    title: 'Plugins',
    'create-button': 'Create Plugin',
    'remove-dialog': {
        title: 'Remove plugin?',
        description: 'Are you sure you want to remove plugin: {plugin}',
    },
    fields: {
        name: 'Name',
        description: 'Description',
        input: 'Plugin test input JSON',
    },
    'has-changes': 'There are unsaved changes in the plugin. Are you sure you want to exit?',
    search: 'Search by name',
    import: {
        button: 'Import from JSON',
        title: 'Import Plugins from JSON',
        paste: 'Paste JSON here...',
    },
    export: 'Export as JSON',
    migration: {
        verify: 'Check the new code against the plugin result for the input',
        migrate: 'Migrate to CODE',
        'in-progress': 'The migration can take up to a minute.',
        'invalid-input': 'The input is not valid JSON.',
        failed: 'The migration failed. Try again.',
        attempts: '{count} attempt | {count} attempts',
        changes: 'Changes',
        'no-changes': 'The code needs no change.',
        result: 'Result',
        'plugin-result': 'Plugin result',
        'code-result': 'CODE result',
        'error-type': 'Error type',
        'error-message': 'Error message',
        'console-output': 'Console output',
        replace: 'Replace with CODE task',
        'replace-unverified': 'Replace without verification',
        back: 'Back to plugin',
        status: {
            VERIFIED: {
                label: 'Verified',
                description: 'The CODE task gives the same result as the plugin for the input.',
            },
            UNVERIFIED: {
                label: 'Not verified',
                description: 'The new code was not run. Nothing checks that it gives the same result as the plugin. Review the diff before you replace the task.',
            },
            RESULT_MISMATCH: {
                label: 'Result mismatch',
                description: 'The CODE task gives a different result than the plugin for the input. The task stays a plugin.',
            },
            EVALUATION_FAILED: {
                label: 'Code failed',
                description: 'The new code failed in the CODE runtime. The task stays a plugin.',
            },
        },
    },
}
